var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 15.1035,
    width: 5.26265,
    height: 4.14684,
    rx: 1.25,
    stroke: "#B097DE",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: -0.75,
    width: 5.26264,
    height: 4.14684,
    rx: 1.25,
    transform: "matrix(1 0 0 -1 12.6947 8.14746)",
    stroke: "#B097DE",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.75,
    y: 4.75,
    width: 5.26265,
    height: 6.97026,
    rx: 1.25,
    stroke: "#B097DE",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: -0.75,
    width: 5.26264,
    height: 6.97026,
    rx: 1.25,
    transform: "matrix(1 0 0 -1 12.6947 18.499)",
    stroke: "#B097DE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEmpty);
export default __webpack_public_path__ + "static/media/dashboardEmpty.b5456cc3.svg";
export { ForwardRef as ReactComponent };